import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import css from './ColorModal.module.css'
import tbl from '../../../../assets/Style/Table.module.css' 
import { AppContext } from '../../../../providers/appProvider';
import Comment from "../../../../assets/Icon/Comment";
import { useComment } from '../../../../hooks/useComment';
import Remove from '../../../../assets/Icon/Remove';
import Select from "react-select"; 
import { selectStyle } from '../TransactionModal/selectStyle';
import { useTranslation } from 'react-i18next';

const CommentModal = ({ carService, car }) => { 
  const {t} = useTranslation();
  
  const { commentService } = useComment(car.id);

  const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "იან",
        "თებ",
        "მარ",
        "აპრ",
        "მაი",
        "ივნ",
        "ივლ",
        "აგვ",
        "სექ",
        "ოქტ",
        "ნოე",
        "დეკ"
    ];

    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month}  ${year}`;
  };

  const colorOptions = [ 
      '#ff0000',
      '#feaec9',
      '#00ffff',
      '#ffff00', 
      '#bcbd00', 
      '#b5e51d', 
      '#9ad9ea',
      '#7092bf',
      '#ffffb9',
      '#ff5f77',
    ];
 
  const defaultColor = '';

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { appState, app } = useContext(AppContext);
 
  const [selectedColor, setSelectedColor] = useState(defaultColor);
  const [textValue, setTextValue] = useState("");
  const users = appState.salers.map((user) => ({ value: user.id, label: user.firstname + " " + user.lastname })); 

  const [newComment, setNewComment] = useState({
    color: defaultColor ,
    content: "",
    comment_author_id: 0,
    target_user_id: 0,
    car_id: car.id,
})
 
  const style = {
    width: '60px',
    height: '20px',
    color: '#64748b',
    backgroundColor: newComment.color || '',
  };

  const handleColorSelection = (newColor) => { 
    if (newColor === newComment.color) { 
      setNewComment({
        ...newComment,
        color: ''
    });
     } else {
      setNewComment({
        ...newComment,
        color: newColor
    });
    }
   };

  const handleTextChange = (e) => { 
     setNewComment({
      ...newComment,
      content: e.target.value
  });
  };

  const addCommentButtonHandle = () => {
    commentService.addComment(newComment)
      .then((response) => {
        carService.fetchCars()
      })
      .catch((error) => {
        app.setError("შეცდომა დამატებისას")
      });
  };

   
  const openDelete = () => {
    setIsModalOpen(true)
  }

  const closeDelete = () => {
    setIsModalOpen(false)
  }

  var isDeletePerm = false
  var isAddPerm = false

  if (app.hasPermission("COMPANY_PAID_DELETE")) {
    isDeletePerm = true 
  }

  if (app.hasPermission("COMPANY_PAID_ADD")) {
      isAddPerm = true 
  }

  useEffect(() => {
    setNewComment({
      ...newComment,
      color: car.color
  });
  }, [car]);

  const onRemove = (id) => {
    commentService.removeComment(id)
        .then(response => {
            carService.fetchCars()
        })
        .catch(error => {
            console.error(error);
        });
  }

  return (
    <>
      <span className={css.btn} onClick={() => openDelete()} >
        <Comment /> { t('Comment') }   
      </span>

      <Modal key={car.id} size="large" isOpen={isModalOpen} onClose={() => closeDelete()}>
        <div> 
          <div className={css.modalHead} >
            <h3>
              <span className={css.iconHead} > <Comment/></span>
              { t('Comment') }   
            </h3>
          </div>
          <div className={tbl.table  } style={{ minHeight: '50px' }}>

          <table>
                            <thead>
                                <tr>
                                    <th className={css.id}>#</th> 
                                    <th>{ t('Comment') }   </th> 
                                    <th>{ t('Color') }   </th>
                                    <th>{ t('Author') }</th>
                                    <th>{ t('ForUser') }</th> 
                                    <th>{ t('Date')}</th>
                                    <th className={css.btntbl}> </th>
                                </tr>
                            </thead>
                            <tbody>
                              {car.comments && car.comments.length > 0 ? (
                                  car.comments.map((comment, index) => (
                                      <tr key={index}>
                                          <td className={css.id}>{index + 1}</td>
                                          <td>{comment.content}</td>
                                          <td>
                                            <div style={{ backgroundColor: comment.color, borderRadius: 5,  display: 'block',   height: 25, width: 100 }}></div>  
                                          </td>
                                          <td>
                                              {comment.comment_author && comment.comment_author.firstname && comment.comment_author.lastname ? 
                                                  `${comment.comment_author.firstname} ${comment.comment_author.lastname}` : 
                                                  ''}
                                          </td>
                                          <td>
                                              {comment.target_user && comment.target_user.firstname && comment.target_user.lastname ? 
                                                  `${comment.target_user.firstname} ${comment.target_user.lastname}` : 
                                                  ''}
                                          </td>
                                          <td>{formatDate(comment.created_at)}</td>
                                          <td className={css.btntbl}>
                                              {isDeletePerm && (
                                                  <div className={css.btns}>
                                                      <div>
                                                          <span className={css.removeBtn} onClick={() => onRemove(comment.id)}><Remove /> წაშლა</span>
                                                      </div>
                                                  </div>
                                              )}
                                          </td>
                                      </tr>
                                  ))
                              ) : (
                                  <tr>
                                      <td colSpan="7">{t('NoComment')}</td>
                                  </tr>
                              )}
                             </tbody>
           </table>
           </div>


          <div className={css.form}>
            <textarea
                placeholder={t('Comment')}
                value={newComment.content}
                onChange={handleTextChange}
                rows="7"
                cols="10"
                className={css.customtextarea}
            ></textarea>

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" , marginTop: "10px"}}>
                <div style={{ width: "100%", maxWidth: "300px" }}>
                
                <Select
                    styles={selectStyle}
                    options={users}
                    value={users.find(option => option.value === newComment.target_user_id)}
                    onChange={(selectedOption) => {
                    setNewComment(prevState => ({
                        ...prevState,
                        target_user_id: selectedOption ? selectedOption.value : 0,
                    }));
                    }}
                    placeholder={t('ForUser')}
                />

                </div>
            </div>
          
          </div>
       

          <div className={css.colorSelector}>
            {colorOptions.map((color, index) => (
              <div
                key={index}
                className={`color-option ${newComment.color === color ? 'selected' : ''}`}
                style={{
                  backgroundColor: color,
                  border: `2px solid ${newComment.color === color ? 'black' : 'transparent'}`, // Border style
                  borderRadius: '50%', // Make it a circle
                  width: '40px', // Set width and height to your desired size
                  height: '40px',
                  cursor: 'pointer', // Add pointer cursor for interaction
                  display: 'inline-block', // Display options inline
                  margin: '0 8px', // Add margin for spacing between options
                }}
                onClick={() => handleColorSelection(color)}
              ></div>
            ))}
          </div>

          {newComment.color && newComment.color.length > 0 && (
            <div style={{ color: 'rgb(100 116 139)' }}>
            {t('SelectedColor')}: <div style={style}></div>
            </div>
            )}
           
          <span onClick={addCommentButtonHandle} style={{ marginLeft: 'auto' }} className={css.btnPrimary}>{t('Save')}</span>


        </div>
      </Modal>
    </>
  );
};

export default CommentModal;